<template>
	<div v-if="store.isLoading" class="flex justify-center w-full py-5">
		<app-loader size="large" />
	</div>

	<div v-else-if="store.journey">
		<app-alert v-if="!auth.vehicleLocked" theme="warning" compact>
			<div class="flex w-full justify-between items-center text-xs">
				Please confirm your vehicle to begin
				<app-button to="/driver-app" size="x-small" theme="warning"> Back </app-button>
			</div>
		</app-alert>

		<app-title-bar
			:icon="['fas', 'fa-truck']"
			:subtitle="store.journey.type == 'COL' ? 'Collection' : 'Delivery'"
			:title="store.journey.journey_number"
			mobile>
			<div class="flex gap-3">
				<app-button to="/driver-app" size="small" icon="fa-home" class="whitespace-nowrap">
					Return
				</app-button>
			</div>
		</app-title-bar>

		<div v-if="store.resumed">
			<app-alert theme="warning" compact class="mb-0">
				Your progress has been resumed

				<app-button
					theme="warning"
					size="x-small"
					class="ms-auto"
					@click="reloadJourney = true">
					<app-icon :icon="['fas', 'fa-rotate-right']" />
				</app-button>

				<app-button theme="success" size="x-small" @click="store.saveJourney()">
					<app-icon :icon="['fas', 'fa-save']" />
				</app-button>
			</app-alert>

			<confirm
				:open="reloadJourney"
				theme="warning"
				@confirmed="store.reloadJourney()"
				@canceled="reloadJourney = false">
				Are you sure you want to force reload the journey data? You may lose unsaved changes
			</confirm>
		</div>

		<slot>
			<slot v-if="auth.vehicleLocked || store.journey.complete" name="action"></slot>
		</slot>
	</div>

	<app-alert v-else>Journey data unavailable</app-alert>
</template>

<script lang="ts" setup>
	import { ref, onMounted } from 'vue'
	import useDriverApp from '@/stores/driver-app'
	import useAuthStore from '@/stores/auth'
	import Confirm from '@/components/partials/dialogs/Confirm.vue'

	const store = useDriverApp()
	const auth = useAuthStore()

	const props = defineProps({
		save: Boolean
	})

	const reloadJourney = ref(false)

	const emit = defineEmits(['initialised'])

	onMounted(async () => {
		await store
			.initialise(!store.journey?.complete && auth.vehicleLocked ? props.save : false)!
			.then(() => {
				emit('initialised')
			})
	})
</script>
